export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=8f59dbb4&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/Reassignation/index.vue?vue&type=template&id=8f59dbb4&scoped=true
// module id = 1722
// module chunks = 31